import { useCallback } from "react";
import { updatePreferences, usePreferences } from "./preferences";

// View preferences, now part of the saved Mail preferences (lib/preferences.ts):
// kept per user in this browser's mirror AND on the account, so they follow the
// person to every device. Hook signatures are unchanged for existing callers.

/** Gmail "Conversation view" / Outlook "Show as conversations". On by default. */
export function useConversationView(): [boolean, (value: boolean) => void] {
    const value = usePreferences((p) => p.layout.conversationView);
    const set = useCallback((next: boolean) => updatePreferences({ layout: { conversationView: next } }), []);
    return [value, set];
}

/** Gmail "Keyboard shortcuts on/off". On by default. */
export function useShortcutsEnabled(): [boolean, (value: boolean) => void] {
    const value = usePreferences((p) => p.general.keyboardShortcuts);
    const set = useCallback((next: boolean) => updatePreferences({ general: { keyboardShortcuts: next } }), []);
    return [value, set];
}
